var map = {
	"./amerknife.png": 7544,
	"./bar.png": 1665,
	"./bayonet.png": 9287,
	"./buttsmack.png": 3158,
	"./colt.png": 9416,
	"./garand.png": 4346,
	"./grenade.png": 2361,
	"./grenade2.png": 3510,
	"./k43.png": 189,
	"./kar.png": 1312,
	"./luger.png": 7675,
	"./mp40.png": 2079,
	"./mp44.png": 4557,
	"./scopedkar.png": 5755,
	"./spade.png": 4078,
	"./spring.png": 2375,
	"./thompson.png": 9040
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3559;